<nav class="bottom-nav">
  <a
    routerLink="/boost"
    routerLinkActive="active"
    class="nav-item"
    [attr.aria-label]="'clientNavbar.boost' | transloco">
    <lucide-icon name="Rocket" class="nav-icon" aria-hidden="true"></lucide-icon>
  </a>
  <a
    routerLink="/orders"
    routerLinkActive="active"
    class="nav-item"
    [attr.aria-label]="'clientNavbar.orders' | transloco">
    <lucide-icon name="ShoppingCart" class="nav-icon" aria-hidden="true"></lucide-icon>
  </a>
  <button
    type="button"
    (click)="openProfile()"
    class="nav-item"
    [attr.aria-label]="'common.a11y.profile' | transloco">
    <lucide-icon name="User" class="nav-icon" aria-hidden="true"></lucide-icon>
  </button>
</nav>
